export type MoodCategoryOption = {
  value: string;
  label: string;
};

export const MOOD_CATEGORY_OPTIONS: MoodCategoryOption[] = [
  { value: "active", label: "発散したい" },
  { value: "relax", label: "癒されたい" },
  { value: "experience", label: "体感したい" },
  { value: "food", label: "食べたい" },
  { value: "shopping", label: "買いたい" }
];
